import { render, staticRenderFns } from "./ScholarshipStudentList.vue?vue&type=template&id=0289d274&"
import script from "./ScholarshipStudentList.vue?vue&type=script&lang=js&"
export * from "./ScholarshipStudentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports